<div class="integrations">
  <div class="integration__label">
    <h3>{{ 'pages.restaurantAccount.integrations' | translate }}</h3>
    <button  *ngIf="isAvailable && editable"
             class="btn btn__primary btn__icon"
             (click)="add.emit()"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        <path d="M0.999878 8H14.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
      </svg>
      <span class="add">{{ 'pages.restaurantAccount.addIntegration' | translate }}</span>
    </button>
  </div>

  <div class="integration__empty" *ngIf="!integrations.length">
    {{ 'pages.restaurantAccount.noIntegrations' | translate }}
  </div>

  <div class="integration header" *ngIf="integrations.length">
    <span class="integration__item">{{ 'pages.restaurantAccount.provider' | translate }}</span>
    <span class="integration__item">{{ 'pages.restaurantAccount.credentials' | translate }}</span>
  </div>

  <div class="integration" *ngFor="let integration of integrations">
    <div class="integration__tags">
      <div *ngIf="integration.proxy" class="integration__tag">{{ 'pages.restaurantAccount.proxy' | translate }}</div>
      <div *ngIf="integration.proxyUnifiedMode" class="integration__tag unified">{{ 'pages.restaurantAccount.unified' | translate }}</div>
    </div>

    <ng-container *ngIf="integration.provider === 'VAST'">
      <span class="integration--item">{{integration.provider}}</span>
      <div class="integration--item credentials">
        <div class="integration--item--ell">
          <sub>{{ 'pages.restaurantAccount.adVastTagUrl' | translate }}</sub>
          <span>{{integration.credentials.vastTagUrl}}</span>
        </div>
      </div>
      <div class="integration--item integration__control" *ngIf="editable">
        <button class="btn btn__icon edit-integration" (click)="edit.emit(integration.id)">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24"  height="24" viewBox="0 0 24 24" style=" fill:#000000;">
            <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
          </svg>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="integration.provider === 'vistarMedia'">
      <span class="integration--item">Vistar Media</span>
      <div class="integration--item credentials">
        <div class="integration--item--ell">
          <sub>{{ 'pages.restaurantAccount.adApiKey' | translate }}</sub>
          <span>******</span>
        </div>
        <div class="integration--item--ell">
          <sub>{{ 'pages.restaurantAccount.adNetworkId' | translate }}</sub>
          <span>{{integration.credentials.networkId}}</span>
        </div>
        <div class="integration--item--ell">
          <sub>{{ 'pages.restaurantAccount.adVenueId' | translate }}</sub>
          <span>{{integration.credentials.venueId}}</span>
        </div>
      </div>
      <div class="integration--item integration__control" *ngIf="editable">
        <button class="btn btn__icon edit-integration" (click)="edit.emit(integration.id)">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24"  height="24" viewBox="0 0 24 24" style=" fill:#000000;">
            <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
          </svg>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="integration.provider === 'kelseysMenu'">
      <span class="integration--item">Kelseys Menu</span>
      <div class="integration--item credentials">
        <div class="integration--item--ell">
          <sub>{{ 'pages.restaurantAccount.storeNumber' | translate }}</sub>
          <span>{{integration.credentials.storeNumber}}</span>
        </div>
      </div>
      <div class="integration--item integration__control" *ngIf="editable">
        <button class="btn btn__icon edit-integration" (click)="edit.emit(integration.id)">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24"  height="24" viewBox="0 0 24 24" style=" fill:#000000;">
            <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
          </svg>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="integration.provider === 'bostonPizzaUI'">
      <span class="integration--item">Boston Pizza UI</span>
      <div class="integration--item credentials">
        <div class="integration--item--ell" *ngIf="integration.credentials.controlMusicUrl">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaUIControlMusicUrl' | translate }}</sub>
          <span>{{ integration.credentials.controlMusicUrl }}</span>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.googleReviewsUrl">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaUIGoogleReviewsUrl' | translate }}</sub>
          <span>{{ integration.credentials.googleReviewsUrl }}</span>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.guestSurveyUrl">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaUIGuestSurveyUrl' | translate }}</sub>
          <span>{{ integration.credentials.guestSurveyUrl }}</span>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.notAcceptingRewardsCardsDisclaimer">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaUINotAcceptingRewardsCardsDisclaimer' | translate }}</sub>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.happyHourPilot">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaUIHappyHourPilot' | translate }}</sub>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.interacBanner">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaUIInteracBanner' | translate }}</sub>
        </div>
      </div>
      <div class="integration--item integration__control" *ngIf="editable">
        <button class="btn btn__icon edit-integration" (click)="edit.emit(integration.id)">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24"  height="24" viewBox="0 0 24 24" style=" fill:#000000;">
            <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
          </svg>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="integration.provider === 'bostonPizzaEventsAPI'">
      <span class="integration--item">Boston Pizza Events API</span>
      <div class="integration--item credentials">
        <div class="integration--item--ell" *ngIf="integration.credentials.chapterId">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaEventsAPIChapterId' | translate }}</sub>
          <span>{{ integration.credentials.chapterId }}</span>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.chapterLocation">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaEventsAPIChapterLocation' | translate }}</sub>
          <span>{{ integration.credentials.chapterLocation }}</span>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.chapterTitle">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaEventsAPIChapterTitle' | translate }}</sub>
          <span>{{ integration.credentials.chapterTitle }}</span>
        </div>
        <div class="integration--item--ell" *ngIf="integration.credentials.slug">
          <sub>{{ 'pages.restaurantAccount.bostonPizzaEventsAPISlug' | translate }}</sub>
          <span>{{ integration.credentials.slug }}</span>
        </div>
      </div>
      <div class="integration--item integration__control" *ngIf="editable">
        <button class="btn btn__icon edit-integration" (click)="edit.emit(integration.id)">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24"  height="24" viewBox="0 0 24 24" style=" fill:#000000;">
            <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
          </svg>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="integration.provider === 'foyr'">
      <span class="integration--item">Foyr</span>
      <div class="integration--item credentials">
        <div class="integration--item--ell" *ngIf="integration.credentials.restaurantId">
          <sub>{{ 'pages.restaurantAccount.foyrRestaurantId' | translate }}</sub>
          <span>{{ integration.credentials.restaurantId }}</span>
        </div>
      </div>
      <div class="integration--item integration__control" *ngIf="editable">
        <button class="btn btn__icon edit-integration" (click)="edit.emit(integration.id)">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" stroke="transparent" width="24"  height="24" viewBox="0 0 24 24" style=" fill:#000000;">
            <path d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z"></path>
          </svg>
        </button>
      </div>
    </ng-container>
  </div>
</div>
